import { Pipe, PipeTransform, inject } from '@angular/core'
import { Maybe, TicketStatus } from '@generated/sammathnaur.graphql'
import { TranslateService } from '@ngx-translate/core'
import { constantCase } from 'change-case'

@Pipe({
    name: 'translateTicketStatusPipe',
    standalone: false
})
export class TranslateTicketStatusPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService)

  public transform(ticketStatus?: Maybe<TicketStatus>): string {
    return this.translateService.instant(`TRANSLATE_TICKET_STATUS.${constantCase(ticketStatus || TicketStatus.Canceled)}`)
  }
}
